import axios from 'axios';
import { AuthenticateResponse } from './auth';

const uninterceptedAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('token')!) as AuthenticateResponse;
    if (token && config.headers) {
      config.headers['Authorization'] = 'Bearer ' + token.jwtToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== 'auth/login' && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await uninterceptedAxios.post('auth/refresh-token', {}, { withCredentials: true });
          localStorage.setItem('token', JSON.stringify(rs.data));

          console.log('Access Token was expired, refresh token was sent');

          return api(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export { uninterceptedAxios };
export default api;
